import { Component, OnInit, Input } from '@angular/core';
import { AppSecuredComponent } from 'src/app/app-secured/app-secured.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from '../baseComponent';
import { MsgService } from '../../services/local/msg.service';
import { Router } from '@angular/router';
import { SlidesService } from '../../services/api/slides.service';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';
import { SlideModel } from '../../models/entity/slide.model';
import { ShipmentPopupComponent } from 'src/app/app-secured/dialog-genaral/shipment-popup/shipment-popup.component';
@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styles: [
  ]
})

export class SliderComponent extends BaseComponent implements OnInit {
  // ------------ [Config] ------------
  filterModel: FilterBaseModel = new FilterBaseModel();
  // ------------ [Data] ------------
  sliders: SlideModel[] = [];
  sliderFirst: SlideModel = new SlideModel();
  constructor(
    // ---------------[Constructor]
    protected msgService: MsgService,
    protected router: Router,
    public app: AppSecuredComponent,
    protected dialogService: DialogService,
    private ref: DynamicDialogRef,
    // ---------------[Service]
    protected slidesService: SlidesService,
  ) {
    super(msgService, router);
  }

  ngOnInit(): void {
    this.getSlider();
  }

  async getSlider(): Promise<any> {
    this.filterModel.pageSize = 10;
    const res = await this.slidesService.getListSlide(this.filterModel);
    if (res.data && res.data.length > 0) {
      let datas = res.data as SlideModel[];
      this.sliderFirst = datas[0];
      this.sliders = datas.filter(f => f.id != this.sliderFirst.id);
    }
  }


  openModelShipment(popup: string): void {
    return;
    // this.ref = this.dialogService.open(ShipmentPopupComponent, {
    //   header: '',
    //   width: '60%',
    //   height: '100%',
    //   contentStyle: { 'max-height': '850px', overflow: 'auto', 'overflow-x': 'hidden', position: 'relative' },
    //   baseZIndex: 10000,
    //   data: popup,
    // });
    // this.ref.onClose.subscribe((item?: any) => {
    // });
  }
}
